import React from 'react';
import { Container, Header, Tab } from 'semantic-ui-react';
import DemoManager from './components/DemoManager';

const Management = () => {
  // 탭 컴포넌트는 displayName을 property로 가지고 있어야합니다.
  // DemoManager 컴포넌트 최하단 참고
  const TABS = [DemoManager].map(TabItem);

  return (
    <Container>
      <Header as="h1">
        <span>Management</span>
      </Header>

      <Tab menu={{ secondary: true, pointing: true }} panes={TABS} />
    </Container>
  );
};

export default Management;

const TabItem = (Component) => ({
  menuItem: {
    key: Component.displayName,
    content: Component.displayName,
    style: { fontSize: '20px' },
  },
  render: () => <Component />,
});
